import { styled } from "@mui/material";

export const OpekepeSyncStepStyled = styled("div")({
  marginBottom: "2rem",
  width: "100%",
  "&.disabled": {
    opacity: 0.6,
  },
  "& .step-title": {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    "& p": {
      fontWeight: 600,
    },
    "& .step-index": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      backgroundColor: "#e3e3e3",
    },
  },
  "& .step-content": {
    minHeight: "10px",
    "& > *": {
      marginTop: "0.75rem",
    },
    "& .content-row": {
      display: "flex",
      justifyContent: "space-between",
      "& p:nth-of-type(2)": {
        fontWeight: 600,
      },
    },
    "& .step-loading": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "1rem",
      paddingTop: "1rem",
      "& .loader": {
        width: "max-content",
      },
    },
  },
});
